export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "svh-onboarding-config-shared-lib": { "alerts": { "SETTINGS": { "title": "Changes saved", "description": "Settings have been saved" }, "SETTINGS_FAILED": { "title": "Save error", "description": "Edits to your settings weren't saved" } } } } });
};